import { P as PAY_PREMIUM_LIST, G as GET_CUSTOMER_TYPE_DOMAIN, C as CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, a as GET_DATE_TIME, A as AGENCY_NAME, O as OnlinePayment, b as Cheque, D as DemandDraft, c as CAR_VEHICLE_INSPECTION, K as KASH_PASH_SLIP, I as ISSUE_POLICY } from '../demand-draft-4fa845ea.js';
export { A as AGENCY_NAME, c as CAR_VEHICLE_INSPECTION, e as CUSTOMER_BANK_DETAILS, C as CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, b as Cheque, D as DemandDraft, G as GET_CUSTOMER_TYPE_DOMAIN, a as GET_DATE_TIME, g as GET_INTERMEDIARY_LIST, f as HOUSE_BANK_ACCOUNT_FETCH, H as HOUSE_BANK_BRANCH_FETCH, d as INTERMEDIARY_CD_ACCOUNTS, I as ISSUE_POLICY, K as KASH_PASH_SLIP, L as LOOKUP_INTERMEDIARY, O as OnlinePayment, P as PAY_PREMIUM_LIST, V as VERIFY_ONLINE_TRANSACTION } from '../demand-draft-4fa845ea.js';
export { C as CdWalletHealth, P as PayPremium } from '../pay-premium-health-a36868d1.js';
export { P as firePayPremium } from '../pay-premium-fire-7c1c1c27.js';
import { C as CdWalletTW } from '../pay-premium-two-wheeler-323a6d6a.js';
export { C as CdWalletTW, T as TWPayPremium } from '../pay-premium-two-wheeler-323a6d6a.js';
import { D as Digilink } from '../digilink-57b9be2d.js';
export { D as Digilink } from '../digilink-57b9be2d.js';
import { b as _objectWithoutProperties, c as _slicedToArray, _ as _objectSpread2, a as _toConsumableArray, f as _asyncToGenerator } from '../_rollupPluginBabelHelpers-fb970440.js';
import React, { useState } from 'react';
import { useResponsiveParams, QuantaFormik, NotificationList, useQuantaFormikContext, Paper, DataGridGroup, Text, Button, QuantaForm, MixedGridGroup } from 'quanta-ui';
import { faSpinner, faExclamationTriangle, faCheck, faSave } from '@fortawesome/free-solid-svg-icons';
import 'react-helmet';
import 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@apollo/client';
import '../queries-3df8abcc.js';
import { E as Error } from '../error-ee5266a9.js';
import { L as Loading } from '../loading-c16d3bd3.js';
import '../queries-a3e6305b.js';
import { u as useMutationQuery } from '../useMutationQuery-42b53d8d.js';
import { P as Parse } from '../CurrencyFormater-d288bc4f.js';
import moment from 'moment';
import { u as useFetchQuery } from '../useFetchQuery-56ba5b94.js';
import '../proposal/health/state.js';
import '../queries-9ae26450.js';
import 'react-router';
import 'disable-scroll';
import '../queries-5e809970.js';
import '../queries-86f06197.js';
import '@fortawesome/free-brands-svg-icons';
import '../queries-d745c605.js';
import TermsAndConditions from '../terms-and-conditions-e1c49b6d.js';
import '../exports-166cdf01.js';
import '../ConfigProvider-9522944e.js';
import '../icon-search-idle-a2977e92.js';
import '../permissions.js';
import '../state-a4d3dd58.js';
import '../state-0f17d715.js';
import '../state-92ba719e.js';
import './intermediary/state.js';
import '../quote/health/state.js';
import '../proposal/motor/state.js';
import '../quote/motor/state.js';
import '../quote/fire/state.js';
import '../state-1fb1e261.js';
import '../quote/workmenscompensation/state.js';
import '../state-cd3cac59.js';
import '../state-74edd9f7.js';
import '../state-f2888c41.js';
import '../proposal/fire/state.js';
import '../quote/shopsecure/state.js';
import '../proposal/shopsecure/state.js';
import '../state-1686d318.js';
import '../policy/renewal/health/state.js';
import '../policy/renewal/motor/state.js';
import '../ShortenString-21905b6b.js';
import '../useFetchCacheQuery-88ef52f3.js';
import '../useCoversAndPlans-e373c56e.js';

var _excluded = ["setLoadingStep", "setCustomLoadingMessage", "setParentAlerts", "showSuccessMsg", "setShowWizardButtonPanel", "productCode", "productName", "productType", "lobCode", "lobName", "REACTIVE_VAR_QUERY", "updateReactiveVar", "reactiveVarName", "modeOfOperation", "renderExpandedCards", "setButtonDisable", "buttonDisable"];
function CarPayPremium(_ref) {
  var _data$2, _data$2$intermediaryD, _data$3, _data$3$intermediaryD, _reactiveVarData$prem17, _reactiveVarData$prem18, _reactiveVarData$prem19, _PaymentTypeList$, _reactiveVarData$prem20, _reactiveVarData$prem21, _reactiveVarData$busi, _reactiveVarData$prei, _reactiveVarData$prem22, _reactiveVarData$prem23, _reactiveVarData$prem24, _reactiveVarData$prem25, _reactiveVarData$prem26, _reactiveVarData$prem27, _reactiveVarData$prem28, _reactiveVarData$prem29, _reactiveVarData$prem30, _reactiveVarData$prem31, _reactiveVarData$prem32, _reactiveVarData$prem33, _reactiveVarData$prem34, _reactiveVarData$prem35, _dateTimeData$datetim3, _reactiveVarData$prem36, _reactiveVarData$prem37, _reactiveVarData$prem38, _reactiveVarData$prem39, _dateTimeData$datetim5, _reactiveVarData$prem40, _reactiveVarData$prem41;

  var setLoadingStep = _ref.setLoadingStep,
      setCustomLoadingMessage = _ref.setCustomLoadingMessage,
      setParentAlerts = _ref.setParentAlerts,
      showSuccessMsg = _ref.showSuccessMsg,
      setShowWizardButtonPanel = _ref.setShowWizardButtonPanel,
      productCode = _ref.productCode,
      productName = _ref.productName;
      _ref.productType;
      _ref.lobCode;
      _ref.lobName;
      var REACTIVE_VAR_QUERY = _ref.REACTIVE_VAR_QUERY,
      updateReactiveVar = _ref.updateReactiveVar,
      reactiveVarName = _ref.reactiveVarName,
      modeOfOperation = _ref.modeOfOperation,
      renderExpandedCards = _ref.renderExpandedCards,
      setButtonDisable = _ref.setButtonDisable;
      _ref.buttonDisable;
      var props = _objectWithoutProperties(_ref, _excluded);

  var repeatForMobile = 1;
  var repeatForDesktop = 3;
  var mutateQuery = useMutationQuery();
  var fetchQuery = useFetchQuery();

  var _useQuery = useQuery(REACTIVE_VAR_QUERY, {
    onCompleted: function onCompleted(data) {
      var _data$;

      setShowWizardButtonPanel((_data$ = data["".concat(reactiveVarName)]) === null || _data$ === void 0 ? void 0 : _data$.isProposalApplicableForPayment);
    }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  var _useState = useState('Customer'),
      _useState2 = _slicedToArray(_useState, 2),
      PT = _useState2[0],
      setPT = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showterms = _useState4[0],
      setShow = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      ispreinspectionverified = _useState6[0],
      setispreinspectionverified = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      loadingpreinspection = _useState8[0],
      setLoadingpreinspection = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      alerts = _useState10[0],
      setAlerts = _useState10[1]; // const {
  //   loading: dropDownLoading,
  //   error: dropDownError,
  //   data: dropDownData,
  // } = useQuery(PAY_PREMIUM_LIST);


  var _useQuery2 = useQuery(PAY_PREMIUM_LIST, {
    skip: data ? false : true,
    variables: {
      imdCode: (_data$2 = data["".concat(reactiveVarName)]) !== null && _data$2 !== void 0 && (_data$2$intermediaryD = _data$2.intermediaryDetails) !== null && _data$2$intermediaryD !== void 0 && _data$2$intermediaryD.code ? "".concat((_data$3 = data["".concat(reactiveVarName)]) === null || _data$3 === void 0 ? void 0 : (_data$3$intermediaryD = _data$3.intermediaryDetails) === null || _data$3$intermediaryD === void 0 ? void 0 : _data$3$intermediaryD.code) : ''
    }
  }),
      dropDownLoading = _useQuery2.loading,
      dropDownError = _useQuery2.error,
      dropDownData = _useQuery2.data;

  var _useQuery3 = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first'
  }),
      loadingCustTypeDomain = _useQuery3.loading,
      errorCustTypeDomain = _useQuery3.error,
      dataCustTypeDomain = _useQuery3.data;

  var _useQuery4 = useQuery(CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first'
  }),
      dropDownLoadingCustomer = _useQuery4.loading,
      errorDownDetailsCustomer = _useQuery4.error,
      dropDownDetailsCustomer = _useQuery4.data;

  var _useQuery5 = useQuery(GET_DATE_TIME),
      dateTimeLoading = _useQuery5.loading,
      errorTimeLoading = _useQuery5.error,
      dateTimeData = _useQuery5.data;

  var _useQuery6 = useQuery(AGENCY_NAME, {
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        productCode: "All",
        domainType: 'Agency Name'
      }
    },
    onCompleted: function onCompleted(data) {}
  }),
      loadingAgency = _useQuery6.loading;
      _useQuery6.error;
      var AgencyData = _useQuery6.data;

  var getDomainData = function getDomainData(domainArr, searchText, searchType, returnType) {
    return domainArr.find(function (d) {
      return d["".concat(searchType)] === searchText;
    }) ? domainArr.find(function (d) {
      return d["".concat(searchType)] === searchText;
    })["".concat(returnType)] : '';
  };

  var reformData = function reformData(val, returnType, isString) {
    return val && val.toString().trim() !== '' ? isString === undefined || isString === true ? "".concat(val) : val : returnType;
  };

  var repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop
  });

  var RenewPayPremiumForm = function RenewPayPremiumForm(_ref2) {
    var _reactiveVarData$prem, _data$4, _values$preinspection, _data$5, _reactiveVarData$revi3, _data$6, _data$6$premiumData, _data$7, _data$7$premiumDetail, _data$7$premiumDetail2, _data$8, _data$8$premiumDetail, _data$8$premiumDetail2, _dateTimeData$datetim, _dateTimeData$datetim2;

    _ref2.validate;

    var _useQuantaFormikConte = useQuantaFormikContext(),
        values = _useQuantaFormikConte.values;
        _useQuantaFormikConte.setFieldValue;

    var paymentMethod = values.paymentMethod;
    var gridData = [{
      title: 'Payment Summary',
      grid_type: 'data',
      grid_data: [{
        text: /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(DataGridGroup, _objectSpread2({
          data: [{
            grid_data: [{
              label: 'Annual Premium (inclusive of all taxes)',
              text: /*#__PURE__*/React.createElement(Text, {
                type: "larger",
                severity: "info",
                className: "space-x-2"
              }, /*#__PURE__*/React.createElement("span", null, Parse(reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem = reactiveVarData.premiumData) === null || _reactiveVarData$prem === void 0 ? void 0 : _reactiveVarData$prem.totalPremium))),
              colSpan: 2
            }]
          }]
        }, {
          flow: 'cols',
          repeat: repeat,
          gapX: 6,
          gapY: 0,
          spaceY: 2,
          size: 'full',
          textType: 'normal',
          useExpandablePaper: false
        }))),
        colSpan: repeat
      }]
    }].concat(_toConsumableArray((_data$4 = data["".concat(reactiveVarName)]) !== null && _data$4 !== void 0 && _data$4.isProposalApplicableForPayment ? [{
      title: /*#__PURE__*/React.createElement(React.Fragment, null, "Confirmation", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: "error",
        type: "title"
      }, "*")),
      grid_data: [{
        type: 'checkbox',
        name: 'termsAndConditions',
        label: /*#__PURE__*/React.createElement("span", null, "I have read and agree to the", ' ', /*#__PURE__*/React.createElement("span", {
          className: "text-secondary underline cursor-pointer",
          onClick: function onClick(_) {
            return setShow(true);
          } //  <TermsAndConditions></TermsAndConditions>
          // window.open(
          //   `/quote/${product_code}/termsAndConditions`,
          //   '_blank',
          // )

        }, "Terms and Conditions"), ' ', "of the policy"),
        colSpan: repeat
      }]
    }, (values === null || values === void 0 ? void 0 : (_values$preinspection = values.preinspectionDetails) === null || _values$preinspection === void 0 ? void 0 : _values$preinspection.isVehicleInspectionNeeded) === true ? {
      title: 'Pre-Inspection Details',
      // grid_type: 'data',
      grid_data: [{
        type: 'select',
        size: 'large',
        // disabled: buyMotorPolicy?.proposalNumber?.length > 0,
        colSpan: repeat === repeatForMobile ? repeat : 1,
        label: /*#__PURE__*/React.createElement(React.Fragment, null, "Preinspection Agency Name", ' ', /*#__PURE__*/React.createElement(Text, {
          severity: 'error'
        }, "*")),
        name: 'preinspectionDetails.preinspectionAgencyName',
        data: MapAgencyData && (MapAgencyData === null || MapAgencyData === void 0 ? void 0 : MapAgencyData.length) > 0 ? _toConsumableArray(MapAgencyData === null || MapAgencyData === void 0 ? void 0 : MapAgencyData.map(function (val) {
          return {
            label: val !== null && val !== void 0 && val.value ? "".concat(val.value) : '',
            value: val !== null && val !== void 0 && val.code ? "".concat(val.code) : ''
          };
        })) : [],
        onDataChange: function onDataChange(val, _) {
          setispreinspectionverified(null);
        }
      }, {
        type: 'text',
        // disabled: buyMotorPolicy?.proposalNumber?.length > 0,
        colSpan: repeat === repeatForMobile ? repeat : 1,
        label: /*#__PURE__*/React.createElement(React.Fragment, null, "Pre-Inspection Number", ' ', /*#__PURE__*/React.createElement(Text, {
          severity: 'error'
        }, "*")),
        name: 'preinspectionDetails.preInspectionNumber',
        onDataChange: function onDataChange(val, _) {
          setispreinspectionverified(null);
        }
      }, {
        type: 'date',
        colSpan: repeat === repeatForMobile ? repeat : 1,
        label: /*#__PURE__*/React.createElement(React.Fragment, null, "Preinspection Date", ' ', /*#__PURE__*/React.createElement(Text, {
          severity: 'error'
        }, "*")),
        onDataChange: function onDataChange(val, _) {
          setispreinspectionverified(null);
        },
        name: 'preinspectionDetails.preinspectionDatetime'
      }, {
        type: 'text',
        colSpan: repeat === repeatForMobile ? repeat : 1,
        placeholder: "Enter time in 24 hrs format",
        label: /*#__PURE__*/React.createElement(React.Fragment, null, "Preinspection Time", ' ', /*#__PURE__*/React.createElement(Text, {
          severity: 'error'
        }, "*")),
        onDataChange: function onDataChange(val, _) {
          setispreinspectionverified(null);
        },
        name: 'preinspectionDetails.preinspectiontime'
      }, {
        type: 'select',
        // disabled: buyMotorPolicy?.proposalNumber?.length > 0,
        colSpan: repeat === repeatForMobile ? repeat : 1,
        label: /*#__PURE__*/React.createElement(React.Fragment, null, "Status - recommended ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        name: 'preinspectionDetails.status',
        data: [{
          label: 'Recommended',
          value: 'Recommended'
        }, {
          label: 'Not Recommended',
          value: 'Not Recommended'
        }],
        onDataChange: function onDataChange(val, _) {
          setispreinspectionverified(null);
        }
      }, {
        type: 'text',
        size: 'large',
        colSpan: repeat === repeatForMobile ? repeat : 1,
        label: /*#__PURE__*/React.createElement(React.Fragment, null, "Remarks", ' ', /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, " *")),
        onDataChange: function onDataChange(val, _) {
          setispreinspectionverified(null);
        },
        name: 'preinspectionDetails.remarks'
      }, {
        type: 'render',
        colSpan: 3,
        component: function component() {
          return /*#__PURE__*/React.createElement("div", {
            //  className="mb-2"
            // className={'flex space-x-4 items-center justify-end mr-2 space-y-4'}
            className: 'w-full flex justify-end mt-6'
          }, /*#__PURE__*/React.createElement(Button, {
            disabled: loadingpreinspection // size="small"
            ,
            type: 'button',
            flat: false // disabled={}
            //className="w-30 space-y-4"
            ,
            className: " w-40 h-11 ",
            iconPre: /*#__PURE__*/React.createElement("div", {
              className: "text-base"
            }, loadingpreinspection ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faSpinner,
              spin: true,
              className: 'mx-2'
            }) : ispreinspectionverified === false ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faExclamationTriangle,
              className: 'mx-2'
            }) : ispreinspectionverified ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faCheck,
              className: 'mx-2'
            }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
              icon: faSave,
              className: 'mx-2'
            })),
            onClick: /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_) {
                var _values$preinspection2, _values$preinspection3, _values$preinspection4, _values$preinspection5, _values$preinspection6, _values$preinspection7, _reactiveVarData$poli, _reactiveVarData$vehi, _reactiveVarData$vehi2, _reactiveVarData$inte, _verificationData$car, verifyTransactionId, _yield$verifyTransact, verificationData;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (Object.keys(validatePreinspection(values)).length !== 0) {
                          setAlerts([{
                            header: '',
                            id: Date.now(),
                            content: /*#__PURE__*/React.createElement("div", {
                              className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                            }, /*#__PURE__*/React.createElement("span", null, "Please fill Vehicle Inspection Details")),
                            type: 'warning',
                            timeout: null,
                            disableClose: false
                          }]);
                          window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                          });
                        }

                        if (!(Object.keys(validatePreinspection(values)).length === 0)) {
                          _context.next = 21;
                          break;
                        }

                        _context.prev = 2;
                        verifyTransactionId = fetchQuery({
                          query: CAR_VEHICLE_INSPECTION,
                          fetchPolicy: 'network-only',
                          variables: {
                            input: {
                              proposalNumber: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber,
                              preInspectionDate: values === null || values === void 0 ? void 0 : (_values$preinspection2 = values.preinspectionDetails) === null || _values$preinspection2 === void 0 ? void 0 : _values$preinspection2.preinspectionDatetime,
                              preInspectionTime: values === null || values === void 0 ? void 0 : (_values$preinspection3 = values.preinspectionDetails) === null || _values$preinspection3 === void 0 ? void 0 : _values$preinspection3.preinspectiontime,
                              preInspectionAgency: values === null || values === void 0 ? void 0 : (_values$preinspection4 = values.preinspectionDetails) === null || _values$preinspection4 === void 0 ? void 0 : _values$preinspection4.preinspectionAgencyName,
                              preInspectionStatus: values === null || values === void 0 ? void 0 : (_values$preinspection5 = values.preinspectionDetails) === null || _values$preinspection5 === void 0 ? void 0 : _values$preinspection5.status,
                              preInspectionremarks: values === null || values === void 0 ? void 0 : (_values$preinspection6 = values.preinspectionDetails) === null || _values$preinspection6 === void 0 ? void 0 : _values$preinspection6.remarks,
                              preInspectionNo: values === null || values === void 0 ? void 0 : (_values$preinspection7 = values.preinspectionDetails) === null || _values$preinspection7 === void 0 ? void 0 : _values$preinspection7.preInspectionNumber,
                              productCode: productCode,
                              startDate: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$poli = reactiveVarData.policy) === null || _reactiveVarData$poli === void 0 ? void 0 : _reactiveVarData$poli.startDate,
                              Regno: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$vehi = reactiveVarData.vehicleTabDetails) === null || _reactiveVarData$vehi === void 0 ? void 0 : (_reactiveVarData$vehi2 = _reactiveVarData$vehi.vehicleRegistrationDetails) === null || _reactiveVarData$vehi2 === void 0 ? void 0 : _reactiveVarData$vehi2.registrationNumber,
                              ImdCode: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$inte = reactiveVarData.intermediaryDetails) === null || _reactiveVarData$inte === void 0 ? void 0 : _reactiveVarData$inte.code
                            }
                          }
                        });
                        setAlerts([]);
                        setLoadingpreinspection(true);
                        _context.next = 8;
                        return verifyTransactionId;

                      case 8:
                        _yield$verifyTransact = _context.sent;
                        verificationData = _yield$verifyTransact.data;
                        setLoadingpreinspection(false);

                        if ((_verificationData$car = verificationData.carSecureVehicleInspection) !== null && _verificationData$car !== void 0 && _verificationData$car.PreInspectionstatus) {
                          setispreinspectionverified(true);
                          setButtonDisable(false);
                          setAlerts([{
                            header: '',
                            id: Date.now(),
                            content: /*#__PURE__*/React.createElement("div", {
                              className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                            }, /*#__PURE__*/React.createElement("span", null, "Vehicle Inspection Saved successfully")),
                            type: 'success',
                            timeout: null,
                            disableClose: false
                          }]);
                          window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                          });
                        } else {
                          setispreinspectionverified(false);
                          setLoadingpreinspection(false);
                          setButtonDisable(true); // // setTransactionVerified(false);
                          // setAlerts([
                          //   {
                          //     header: '',
                          //     id: Date.now(),
                          //     content: (
                          //       <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                          //         <span>
                          //           Transaction ID cannot be verified.
                          //           Please try with some other transaction
                          //           ID.
                          //         </span>
                          //       </div>
                          //     ),
                          //     type: 'error',
                          //     timeout: null,
                          //     disableClose: false,
                          //   },
                          // ]);
                          // window.scrollTo({ top: 0, behavior: 'smooth' });
                        }

                        _context.next = 21;
                        break;

                      case 14:
                        _context.prev = 14;
                        _context.t0 = _context["catch"](2);
                        // setLoadingTransaction(false);
                        // setTransactionVerified(false);
                        setispreinspectionverified(false);
                        setLoadingpreinspection(false);
                        setButtonDisable(true);
                        setAlerts([{
                          header: 'Vehicle Inspection  failure',
                          id: Date.now(),
                          content: /*#__PURE__*/React.createElement("div", {
                            className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                          }, _context.t0.message),
                          type: 'error',
                          timeout: null,
                          disableClose: false
                        }]);
                        window.scrollTo({
                          top: 0,
                          behavior: 'smooth'
                        });

                      case 21:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[2, 14]]);
              }));

              return function (_x) {
                return _ref3.apply(this, arguments);
              };
            }()
          }, loadingpreinspection ? /*#__PURE__*/React.createElement("span", {
            className: "text-base"
          }, "Saving") : ispreinspectionverified === false ? /*#__PURE__*/React.createElement("span", {
            className: "text-base"
          }, "Not Verified") : ispreinspectionverified ? /*#__PURE__*/React.createElement("span", {
            className: "text-base"
          }, "Saved") : /*#__PURE__*/React.createElement("span", {
            className: "text-base"
          }, "Save")));
        }
      }]
    } : null, {
      title: /*#__PURE__*/React.createElement(React.Fragment, null, "Payer Details", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: "error",
        type: "title"
      }, "*")),
      colSpan: repeat,
      grid_data: [{
        type: 'select',
        label: /*#__PURE__*/React.createElement(React.Fragment, null, "Payer Type ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        name: 'payerType',
        size: 'large',
        onDataChange: setPT(values.payerType),
        disableSelect: true,
        colSpan: repeat === repeatForDesktop ? repeat - 2 : repeat,
        data: PayMethodPayerTypeList ? _toConsumableArray(PayMethodPayerTypeList === null || PayMethodPayerTypeList === void 0 ? void 0 : PayMethodPayerTypeList.map(function (payerType) {
          return {
            label: payerType !== null && payerType !== void 0 && payerType.value ? payerType === null || payerType === void 0 ? void 0 : payerType.value : '',
            value: payerType !== null && payerType !== void 0 && payerType.code ? payerType === null || payerType === void 0 ? void 0 : payerType.code : ''
          };
        })) : []
      }, {
        type: 'render',
        colSpan: repeat === repeatForDesktop ? repeat - 1 : repeat,
        component: function component() {
          var _reactiveVarData$prop, _reactiveVarData$prop2, _reactiveVarData$prop3, _reactiveVarData$prop4, _reactiveVarData$prop5, _reactiveVarData$prop6, _reactiveVarData$prop7, _reactiveVarData$prop8, _reactiveVarData$prop9, _reactiveVarData$prop10, _reactiveVarData$inte2;

          return /*#__PURE__*/React.createElement("span", {
            className: "flex flex-col mb-4"
          }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Text, {
            type: "label"
          }, "Payer Name")), /*#__PURE__*/React.createElement("div", {
            className: "break-all"
          }, (values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') ? (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop === void 0 ? void 0 : _reactiveVarData$prop.customerType) === getDomainData(customerTypeList, 'Individual', 'value', 'code') ? [getDomainData(salutationList, reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop2 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop2 === void 0 ? void 0 : (_reactiveVarData$prop3 = _reactiveVarData$prop2.title) === null || _reactiveVarData$prop3 === void 0 ? void 0 : _reactiveVarData$prop3.trim(), 'code', 'value'), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop4 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop4 === void 0 ? void 0 : (_reactiveVarData$prop5 = _reactiveVarData$prop4.firstName) === null || _reactiveVarData$prop5 === void 0 ? void 0 : _reactiveVarData$prop5.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop6 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop6 === void 0 ? void 0 : (_reactiveVarData$prop7 = _reactiveVarData$prop6.middleName) === null || _reactiveVarData$prop7 === void 0 ? void 0 : _reactiveVarData$prop7.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop8 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop8 === void 0 ? void 0 : (_reactiveVarData$prop9 = _reactiveVarData$prop8.lastName) === null || _reactiveVarData$prop9 === void 0 ? void 0 : _reactiveVarData$prop9.trim()].filter(function (n) {
            return n;
          }).join(' ') : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop10 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop10 === void 0 ? void 0 : _reactiveVarData$prop10.orgName : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$inte2 = reactiveVarData.intermediaryDetails) === null || _reactiveVarData$inte2 === void 0 ? void 0 : _reactiveVarData$inte2.intermediaryName));
        }
      }]
    }, {
      title: /*#__PURE__*/React.createElement(React.Fragment, null, "Choose Payment Method", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: "error",
        type: "title"
      }, "*")),
      colSpan: repeat,
      grid_data: [{
        type: repeat === repeatForDesktop ? 'radiogroup' : 'select',
        colSpan: repeat,
        className: 'mt-1',
        name: 'paymentMethod',
        data: PaymentTypeList ? _toConsumableArray(PaymentTypeList === null || PaymentTypeList === void 0 ? void 0 : PaymentTypeList.map(function (paymentMethod) {
          var _reactiveVarData$revi, _reactiveVarData$revi2;

          if ((values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Intermediary', 'value', 'code') && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value) === 'CD Wallet') {
            return {
              label: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.value ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value : '',
              value: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.code ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.code : ''
            };
          }

          if ((values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$revi = reactiveVarData.reviewAndConfirmTabDetails) === null || _reactiveVarData$revi === void 0 ? void 0 : _reactiveVarData$revi.proposalPaymentType) !== 'OFFLINE') return {
            label: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.value ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value : '',
            value: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.code ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.code : ''
          };
          if ((values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$revi2 = reactiveVarData.reviewAndConfirmTabDetails) === null || _reactiveVarData$revi2 === void 0 ? void 0 : _reactiveVarData$revi2.proposalPaymentType) === 'OFFLINE' && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value) !== 'Digilink' && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value) !== 'Offline Payment') return {
            label: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.value ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.value : '',
            value: paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.code ? paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.code : ''
          };
        }).filter(function (p) {
          return p;
        })) : []
      }]
    }] : [])).filter(function (d) {
      return d;
    });
    var other_props = {
      flow: 'cols',
      repeat: repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      textType: 'normal'
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaForm, {
      className: "space-y-4"
    }, /*#__PURE__*/React.createElement(MixedGridGroup, _objectSpread2({
      data: gridData
    }, other_props))), (_data$5 = data["".concat(reactiveVarName)]) !== null && _data$5 !== void 0 && _data$5.isProposalApplicableForPayment ? paymentMethod === getDomainData(PaymentTypeList, 'Offline Payment', 'value', 'code') && (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$revi3 = reactiveVarData.reviewAndConfirmTabDetails) === null || _reactiveVarData$revi3 === void 0 ? void 0 : _reactiveVarData$revi3.proposalPaymentType) !== 'OFFLINE' && (values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') ? /*#__PURE__*/React.createElement("span", {
      className: "mt-8"
    }, /*#__PURE__*/React.createElement(OnlinePayment, {
      totalPremium: (_data$6 = data["".concat(reactiveVarName)]) === null || _data$6 === void 0 ? void 0 : (_data$6$premiumData = _data$6.premiumData) === null || _data$6$premiumData === void 0 ? void 0 : _data$6$premiumData.totalPremium,
      transactionId: (_data$7 = data["".concat(reactiveVarName)]) === null || _data$7 === void 0 ? void 0 : (_data$7$premiumDetail = _data$7.premiumDetails) === null || _data$7$premiumDetail === void 0 ? void 0 : (_data$7$premiumDetail2 = _data$7$premiumDetail.onlinePayment) === null || _data$7$premiumDetail2 === void 0 ? void 0 : _data$7$premiumDetail2.transactionId,
      isTransactionIdVerified: (_data$8 = data["".concat(reactiveVarName)]) === null || _data$8 === void 0 ? void 0 : (_data$8$premiumDetail = _data$8.premiumDetails) === null || _data$8$premiumDetail === void 0 ? void 0 : (_data$8$premiumDetail2 = _data$8$premiumDetail.onlinePayment) === null || _data$8$premiumDetail2 === void 0 ? void 0 : _data$8$premiumDetail2.isTransactionIdVerified
    })) : paymentMethod === getDomainData(PaymentTypeList, 'Digilink', 'value', 'code') ? /*#__PURE__*/React.createElement(Digilink, {
      reactiveVarName: reactiveVarName,
      REACTIVE_VAR_QUERY: REACTIVE_VAR_QUERY
    }) : paymentMethod === getDomainData(PaymentTypeList, 'CD Wallet', 'value', 'code') //    &&
    // values?.payerType ===
    //   getDomainData(
    //     PayMethodPayerTypeList,
    //     'Intermediary',
    //     'value',
    //     'code',
    //   ) 
    ?
    /*#__PURE__*/
    React.createElement("span", {
      className: "mt-8"
    }, /*#__PURE__*/React.createElement(CdWalletTW, {
      REACTIVE_VAR_QUERY: REACTIVE_VAR_QUERY,
      reactiveVarName: reactiveVarName,
      PT: PT,
      productCode: productCode
    })) : paymentMethod === getDomainData(PaymentTypeList, 'Cheque', 'value', 'code') && (values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') ? /*#__PURE__*/React.createElement("span", {
      className: "mt-8"
    }, /*#__PURE__*/React.createElement(Cheque, {
      data: {
        maxDate: dateTimeData === null || dateTimeData === void 0 ? void 0 : (_dateTimeData$datetim = dateTimeData.datetimeValue) === null || _dateTimeData$datetim === void 0 ? void 0 : _dateTimeData$datetim.date
      },
      renderExpandedCards: renderExpandedCards,
      ChequeTypeList: ChequeTypeList
    }), ' ') : paymentMethod === getDomainData(PaymentTypeList, 'Demand Draft', 'value', 'code') && (values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') ? /*#__PURE__*/React.createElement("span", {
      className: "mt-8"
    }, /*#__PURE__*/React.createElement(DemandDraft, {
      data: {
        maxDate: dateTimeData === null || dateTimeData === void 0 ? void 0 : (_dateTimeData$datetim2 = dateTimeData.datetimeValue) === null || _dateTimeData$datetim2 === void 0 ? void 0 : _dateTimeData$datetim2.date
      },
      renderExpandedCards: renderExpandedCards
    }), ' ') : null : /*#__PURE__*/React.createElement("div", {
      className: "flex items-baseline justify-center mt-5 min-h-screen"
    }, /*#__PURE__*/React.createElement(Text, {
      type: "large",
      severity: "warning",
      className: "text-2xl flex"
    }, /*#__PURE__*/React.createElement(Text, {
      className: "xl:text-2xl text-xl opacity-75"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faExclamationTriangle,
      className: "mr-2"
    })), /*#__PURE__*/React.createElement(Text, {
      className: "xl:text-2xl text-lg opacity-75"
    }, "Pending for Referral Approval . Proposal is not applicable for payment"))));
  };

  if (loading || dropDownLoading || loadingCustTypeDomain || dropDownLoadingCustomer || dateTimeLoading || loadingAgency) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Loading, null));
  }

  if (error || dropDownError || errorCustTypeDomain || errorDownDetailsCustomer || errorTimeLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Error, {
      error: error || dropDownError || errorCustTypeDomain || errorDownDetailsCustomer || errorTimeLoading
    }));
  }

  var reactiveVarData = data["".concat(reactiveVarName)];
  var PayMethodPayerTypeList = dropDownData.PayMethodPayerTypeList,
      PaymentTypeList = dropDownData.PaymentTypeList,
      ChequeTypeList = dropDownData.ChequeTypeList;
  var customerTypeList = dataCustTypeDomain.customerTypeList;
  var salutationList = dropDownDetailsCustomer.salutationList;
  var MapAgencyData = AgencyData === null || AgencyData === void 0 ? void 0 : AgencyData.getDomainData;

  var validate = function validate(values) {
    var _values$preinspection8, _reactiveVarData$prem6, _reactiveVarData$prem7;

    var paymentAmount = 0;
    var errors = {},
        errorCount = 0;
    errors.preinspectionDetails = {}; //  errors.preinspectionDetails = {};

    if ((values === null || values === void 0 ? void 0 : (_values$preinspection8 = values.preinspectionDetails) === null || _values$preinspection8 === void 0 ? void 0 : _values$preinspection8.isVehicleInspectionNeeded) === true) {
      var _values$preinspection9, _values$preinspection10, _values$preinspection11, _values$preinspection12, _values$preinspection13, _values$preinspection14, _values$preinspection15, _moment, _values$preinspection16, _values$preinspection17;

      if (!(values !== null && values !== void 0 && (_values$preinspection9 = values.preinspectionDetails) !== null && _values$preinspection9 !== void 0 && _values$preinspection9.preInspectionNumber)) {
        errors.preinspectionDetails.preInspectionNumber = '* Required';
        errorCount += 1;
      }

      if (!(values !== null && values !== void 0 && (_values$preinspection10 = values.preinspectionDetails) !== null && _values$preinspection10 !== void 0 && _values$preinspection10.preinspectionAgencyName)) {
        errors.preinspectionDetails.preinspectionAgencyName = '* Required';
        errorCount += 1;
      }

      if (!(values !== null && values !== void 0 && (_values$preinspection11 = values.preinspectionDetails) !== null && _values$preinspection11 !== void 0 && _values$preinspection11.preinspectionDatetime)) {
        errors.preinspectionDetails.preinspectionDatetime = '* Required';
        errorCount += 1;
      }

      if (!(values !== null && values !== void 0 && (_values$preinspection12 = values.preinspectionDetails) !== null && _values$preinspection12 !== void 0 && _values$preinspection12.preinspectiontime)) {
        errors.preinspectionDetails.preinspectiontime = '* Required';
        errorCount += 1;
      }

      if (!(values !== null && values !== void 0 && (_values$preinspection13 = values.preinspectionDetails) !== null && _values$preinspection13 !== void 0 && _values$preinspection13.preinspectiontime.match(/^[0-9 :]+$/))) {
        errors.preinspectionDetails.preinspectiontime = '* Please enter time in 24 hrs format';
        errorCount += 1;
      }

      if (!(values !== null && values !== void 0 && (_values$preinspection14 = values.preinspectionDetails) !== null && _values$preinspection14 !== void 0 && _values$preinspection14.remarks)) {
        errors.preinspectionDetails.remarks = '* Required';
        errorCount += 1;
      }

      if (values !== null && values !== void 0 && (_values$preinspection15 = values.preinspectionDetails) !== null && _values$preinspection15 !== void 0 && _values$preinspection15.preinspectionDatetime && (_moment = moment(values === null || values === void 0 ? void 0 : (_values$preinspection16 = values.preinspectionDetails) === null || _values$preinspection16 === void 0 ? void 0 : _values$preinspection16.preinspectionDatetime, 'DD/MM/YYYY')) !== null && _moment !== void 0 && _moment.isAfter()) {
        errors.preinspectionDetails.preinspectionDatetime = '* cannot accept future date';
        errorCount += 1;
      }

      if (!(values !== null && values !== void 0 && (_values$preinspection17 = values.preinspectionDetails) !== null && _values$preinspection17 !== void 0 && _values$preinspection17.status)) {
        errors.preinspectionDetails.status = '* Required';
        errorCount += 1;

        if (errorCount === 0) {
          errors = {};
        }
      }
    }

    if (!(values !== null && values !== void 0 && values.payerType)) {
      errors.payerType = '* Required';
    }

    if (!(values !== null && values !== void 0 && values.paymentMethod)) {
      errors.paymentMethod = '* Required';
    }

    if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Cheque', 'value', 'code')) {
      var _values$cheque;

      errors.cheque = values === null || values === void 0 ? void 0 : (_values$cheque = values.cheque) === null || _values$cheque === void 0 ? void 0 : _values$cheque.map(function (_) {
        return {};
      });
      values === null || values === void 0 ? void 0 : values.cheque.forEach(function (_, idx) {
        var _values$cheque$idx, _values$cheque$idx2, _values$cheque$idx3, _values$cheque$idx4, _values$cheque$idx5, _values$cheque$idx6, _values$cheque$idx7, _values$cheque$idx8, _values$cheque$idx9, _values$cheque$idx10;

        paymentAmount += parseFloat(values === null || values === void 0 ? void 0 : (_values$cheque$idx = values.cheque[idx]) === null || _values$cheque$idx === void 0 ? void 0 : _values$cheque$idx.paymentAmount);

        if (!(values !== null && values !== void 0 && (_values$cheque$idx2 = values.cheque[idx]) !== null && _values$cheque$idx2 !== void 0 && _values$cheque$idx2.ifscCode)) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            ifscCode: '* Required'
          });
        }

        if (values !== null && values !== void 0 && values.cheque[idx].ifscCode && !(values !== null && values !== void 0 && values.cheque[idx].ifscCode.match(/^[a-zA-Z0-9]+$/))) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            ifscCode: '* IFSC Code cannot contain special characters'
          });
        }

        if (!(values !== null && values !== void 0 && (_values$cheque$idx3 = values.cheque[idx]) !== null && _values$cheque$idx3 !== void 0 && _values$cheque$idx3.branchName)) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            branchName: '* Required'
          });
        }

        if (!(values !== null && values !== void 0 && (_values$cheque$idx4 = values.cheque[idx]) !== null && _values$cheque$idx4 !== void 0 && _values$cheque$idx4.bankName)) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            bankName: '* Required'
          });
        } // if (!values?.cheque[idx]?.chequeType) {
        //   errors.cheque[idx] = {
        //     ...errors.cheque[idx],
        //     chequeType: '* Required',
        //   };
        // }


        if (!(values !== null && values !== void 0 && (_values$cheque$idx5 = values.cheque[idx]) !== null && _values$cheque$idx5 !== void 0 && _values$cheque$idx5.chequeDate)) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            chequeDate: '* Required'
          });
        }

        if (!(values !== null && values !== void 0 && (_values$cheque$idx6 = values.cheque[idx]) !== null && _values$cheque$idx6 !== void 0 && _values$cheque$idx6.chequeNumber)) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            chequeNumber: '* Required'
          });
        }

        if (values !== null && values !== void 0 && (_values$cheque$idx7 = values.cheque[idx]) !== null && _values$cheque$idx7 !== void 0 && _values$cheque$idx7.chequeNumber && (values === null || values === void 0 ? void 0 : (_values$cheque$idx8 = values.cheque[idx]) === null || _values$cheque$idx8 === void 0 ? void 0 : _values$cheque$idx8.chequeNumber.length) !== 6) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            chequeNumber: '* Cheque number must be of 6 digits'
          });
        }

        if (!(values !== null && values !== void 0 && (_values$cheque$idx9 = values.cheque[idx]) !== null && _values$cheque$idx9 !== void 0 && _values$cheque$idx9.paymentAmount)) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            paymentAmount: '* Required'
          });
        }

        if (!(values !== null && values !== void 0 && (_values$cheque$idx10 = values.cheque[idx]) !== null && _values$cheque$idx10 !== void 0 && _values$cheque$idx10.branchLocation)) {
          errors.cheque[idx] = _objectSpread2(_objectSpread2({}, errors.cheque[idx]), {}, {
            branchLocation: '* Required'
          });
        }
      });
      values === null || values === void 0 ? void 0 : values.cheque.forEach(function (_, idx) {
        errorCount += Object.keys(errors.cheque[idx]).length;
      });
    } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Demand Draft', 'value', 'code')) {
      var _values$demandDraft, _values$demandDraft2;

      errors.demandDraft = values === null || values === void 0 ? void 0 : (_values$demandDraft = values.demandDraft) === null || _values$demandDraft === void 0 ? void 0 : _values$demandDraft.map(function (demandDraft) {
        return {};
      });
      values === null || values === void 0 ? void 0 : (_values$demandDraft2 = values.demandDraft) === null || _values$demandDraft2 === void 0 ? void 0 : _values$demandDraft2.forEach(function (_, idx) {
        var _values$demandDraft$i, _values$demandDraft$i2, _values$demandDraft$i3, _values$demandDraft$i4, _values$demandDraft$i5, _values$demandDraft$i6, _values$demandDraft$i7, _values$demandDraft$i8, _values$demandDraft$i9, _values$demandDraft$i10, _values$demandDraft$i11, _values$demandDraft$i12, _values$demandDraft$i13, _values$demandDraft3;

        paymentAmount += parseFloat(values === null || values === void 0 ? void 0 : (_values$demandDraft$i = values.demandDraft[idx]) === null || _values$demandDraft$i === void 0 ? void 0 : _values$demandDraft$i.paymentAmount);

        if (!(values !== null && values !== void 0 && (_values$demandDraft$i2 = values.demandDraft[idx]) !== null && _values$demandDraft$i2 !== void 0 && _values$demandDraft$i2.ifscCode)) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            ifscCode: '* Required'
          });
        }

        if (values !== null && values !== void 0 && (_values$demandDraft$i3 = values.demandDraft[idx]) !== null && _values$demandDraft$i3 !== void 0 && _values$demandDraft$i3.ifscCode && !(values !== null && values !== void 0 && (_values$demandDraft$i4 = values.demandDraft[idx]) !== null && _values$demandDraft$i4 !== void 0 && (_values$demandDraft$i5 = _values$demandDraft$i4.ifscCode) !== null && _values$demandDraft$i5 !== void 0 && _values$demandDraft$i5.match(/^[a-zA-Z0-9\s]+$/))) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            ifscCode: '* IFSC Code cannot contain special characters'
          });
        }

        if (!(values !== null && values !== void 0 && (_values$demandDraft$i6 = values.demandDraft[idx]) !== null && _values$demandDraft$i6 !== void 0 && _values$demandDraft$i6.branchName)) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            branchName: '* Required'
          });
        }

        if (!(values !== null && values !== void 0 && (_values$demandDraft$i7 = values.demandDraft[idx]) !== null && _values$demandDraft$i7 !== void 0 && _values$demandDraft$i7.bankName)) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            bankName: '* Required'
          });
        }

        if (!(values !== null && values !== void 0 && (_values$demandDraft$i8 = values.demandDraft[idx]) !== null && _values$demandDraft$i8 !== void 0 && _values$demandDraft$i8.ddDate)) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            ddDate: '* Required'
          });
        }

        if (!(values !== null && values !== void 0 && (_values$demandDraft$i9 = values.demandDraft[idx]) !== null && _values$demandDraft$i9 !== void 0 && _values$demandDraft$i9.ddNumber)) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            ddNumber: '* Required'
          });
        }

        if (values !== null && values !== void 0 && (_values$demandDraft$i10 = values.demandDraft[idx]) !== null && _values$demandDraft$i10 !== void 0 && _values$demandDraft$i10.ddNumber && (values === null || values === void 0 ? void 0 : (_values$demandDraft$i11 = values.demandDraft[idx]) === null || _values$demandDraft$i11 === void 0 ? void 0 : _values$demandDraft$i11.ddNumber.length) !== 6) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            ddNumber: '* DD number must be of 6 digits'
          });
        }

        if (!(values !== null && values !== void 0 && (_values$demandDraft$i12 = values.demandDraft[idx]) !== null && _values$demandDraft$i12 !== void 0 && _values$demandDraft$i12.paymentAmount)) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            paymentAmount: '* Required'
          });
        }

        if (!(values !== null && values !== void 0 && (_values$demandDraft$i13 = values.demandDraft[idx]) !== null && _values$demandDraft$i13 !== void 0 && _values$demandDraft$i13.branchLocation)) {
          errors.demandDraft[idx] = _objectSpread2(_objectSpread2({}, errors.demandDraft[idx]), {}, {
            branchLocation: '* Required'
          });
        }

        values === null || values === void 0 ? void 0 : (_values$demandDraft3 = values.demandDraft) === null || _values$demandDraft3 === void 0 ? void 0 : _values$demandDraft3.forEach(function (_, idx) {
          errorCount += Object.keys(errors.demandDraft[idx]).length;
        });
      });
    } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Offline Payment', 'value', 'code')) {
      var _reactiveVarData$prem2, _values$onlinePayment, _values$onlinePayment2, _values$onlinePayment3, _values$onlinePayment4, _values$onlinePayment5, _values$onlinePayment6;

      paymentAmount = reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem2 = reactiveVarData.premiumData) === null || _reactiveVarData$prem2 === void 0 ? void 0 : _reactiveVarData$prem2.totalPremium;
      errors.onlinePayment = {};

      if (!(values !== null && values !== void 0 && (_values$onlinePayment = values.onlinePayment) !== null && _values$onlinePayment !== void 0 && _values$onlinePayment.transactionId)) {
        errors.onlinePayment.transactionId = '* Required';
      }

      if (values !== null && values !== void 0 && (_values$onlinePayment2 = values.onlinePayment) !== null && _values$onlinePayment2 !== void 0 && _values$onlinePayment2.transactionId && (values === null || values === void 0 ? void 0 : (_values$onlinePayment3 = values.onlinePayment) === null || _values$onlinePayment3 === void 0 ? void 0 : (_values$onlinePayment4 = _values$onlinePayment3.transactionId) === null || _values$onlinePayment4 === void 0 ? void 0 : (_values$onlinePayment5 = _values$onlinePayment4.toString()) === null || _values$onlinePayment5 === void 0 ? void 0 : _values$onlinePayment5.length) < 8 // ||
      //   !values?.onlinePayment?.transactionId?.toString().match(/^[0-9]+$/)
      ) {
        errors.onlinePayment.transactionId = 'Invalid Transaction ID ';
      }

      if (!(values !== null && values !== void 0 && (_values$onlinePayment6 = values.onlinePayment) !== null && _values$onlinePayment6 !== void 0 && _values$onlinePayment6.isTransactionIdVerified)) {
        errors.onlinePayment.isTransactionIdVerified = 'Verify the transaction ID before proceeding';
      }

      errorCount += Object.keys(errors.onlinePayment).length;
    } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'CD Wallet', 'value', 'code')) {
      var _reactiveVarData$prem3, _values$cdWallet;

      paymentAmount = reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem3 = reactiveVarData.premiumData) === null || _reactiveVarData$prem3 === void 0 ? void 0 : _reactiveVarData$prem3.totalPremium;
      errors.cdWallet = {};

      if ((values === null || values === void 0 ? void 0 : (_values$cdWallet = values.cdWallet) === null || _values$cdWallet === void 0 ? void 0 : _values$cdWallet.cdAccountCount) === 0) {
        errors.cdWallet.cdAccountCount = 'No CD Accounts Found. Proceed with any other Payment methods available';
      } else {
        var _values$cdWallet2, _values$cdWallet3, _values$cdWallet4, _reactiveVarData$prem4;

        if (!(values !== null && values !== void 0 && (_values$cdWallet2 = values.cdWallet) !== null && _values$cdWallet2 !== void 0 && _values$cdWallet2.cdAccountNo)) {
          errors.cdWallet.cdAccountNo = '* Required';
        }

        if (values !== null && values !== void 0 && (_values$cdWallet3 = values.cdWallet) !== null && _values$cdWallet3 !== void 0 && _values$cdWallet3.cdAccountBalance && parseFloat(values === null || values === void 0 ? void 0 : (_values$cdWallet4 = values.cdWallet) === null || _values$cdWallet4 === void 0 ? void 0 : _values$cdWallet4.cdAccountBalance) < (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem4 = reactiveVarData.premiumData) === null || _reactiveVarData$prem4 === void 0 ? void 0 : _reactiveVarData$prem4.totalPremium)) {
          errors.cdWallet.cdAccountBalance = '* Insufficient CD Account Balance';
          paymentAmount = 0;
        }
      }

      errorCount += Object.keys(errors.cdWallet).length;
    } else {
      var _reactiveVarData$prem5;

      paymentAmount = reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem5 = reactiveVarData.premiumData) === null || _reactiveVarData$prem5 === void 0 ? void 0 : _reactiveVarData$prem5.totalPremium;
    }

    if (paymentAmount < (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem6 = reactiveVarData.premiumData) === null || _reactiveVarData$prem6 === void 0 ? void 0 : _reactiveVarData$prem6.totalPremium)) {
      errors.totalPaymentAmount = 'Total payment amount should be atleast equal to the total premium amount or balance is not sufficient.';
      errorCount += 1;
    } // if (!values?.preinspectionDetails?.ispreinspectionverified) {
    //   errors.preinspectionDetails.ispreinspectionverified = 'Save PreInspection Details Before Proceeding';
    //   errorCount += 1;
    // }


    if ((values === null || values === void 0 ? void 0 : values.termsAndConditions) === false) {
      errors.termsAndConditions = '* Required';
      errorCount += 1;
    }

    if (errorCount === 0 && paymentAmount >= (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem7 = reactiveVarData.premiumData) === null || _reactiveVarData$prem7 === void 0 ? void 0 : _reactiveVarData$prem7.totalPremium)) {
      errors = {};
    }

    return errors;
  };

  var validatePreinspection = function validatePreinspection(values) {
    var _values$preinspection18;

    var errors = {},
        errorCount = 0;
    errors.preinspectionDetails = {};

    if ((values === null || values === void 0 ? void 0 : (_values$preinspection18 = values.preinspectionDetails) === null || _values$preinspection18 === void 0 ? void 0 : _values$preinspection18.isVehicleInspectionNeeded) === true) {
      var _values$preinspection19, _values$preinspection20, _values$preinspection21, _values$preinspection22, _values$preinspection23, _values$preinspection24, _values$preinspection25, _moment2, _values$preinspection26;

      if (!(values !== null && values !== void 0 && (_values$preinspection19 = values.preinspectionDetails) !== null && _values$preinspection19 !== void 0 && _values$preinspection19.preInspectionNumber)) {
        errors.preinspectionDetails.preInspectionNumber = '* Required';
        errorCount += 1;
      }

      if (!(values !== null && values !== void 0 && (_values$preinspection20 = values.preinspectionDetails) !== null && _values$preinspection20 !== void 0 && _values$preinspection20.preinspectionAgencyName)) {
        errors.preinspectionDetails.preinspectionAgencyName = '* Required';
        errorCount += 1;
      }

      if (!(values !== null && values !== void 0 && (_values$preinspection21 = values.preinspectionDetails) !== null && _values$preinspection21 !== void 0 && _values$preinspection21.preinspectionDatetime)) {
        errors.preinspectionDetails.preinspectionDatetime = '* Required';
        errorCount += 1;
      }

      if (!(values !== null && values !== void 0 && (_values$preinspection22 = values.preinspectionDetails) !== null && _values$preinspection22 !== void 0 && _values$preinspection22.preinspectiontime)) {
        errors.preinspectionDetails.preinspectiontime = '* Required';
        errorCount += 1;
      }

      if (!(values !== null && values !== void 0 && (_values$preinspection23 = values.preinspectionDetails) !== null && _values$preinspection23 !== void 0 && _values$preinspection23.remarks)) {
        errors.preinspectionDetails.remarks = '* Required';
        errorCount += 1;
      }

      if (!(values !== null && values !== void 0 && (_values$preinspection24 = values.preinspectionDetails) !== null && _values$preinspection24 !== void 0 && _values$preinspection24.status)) {
        errors.preinspectionDetails.status = '* Required';
        errorCount += 1;
      }

      if (values !== null && values !== void 0 && (_values$preinspection25 = values.preinspectionDetails) !== null && _values$preinspection25 !== void 0 && _values$preinspection25.preinspectionDatetime && (_moment2 = moment(values === null || values === void 0 ? void 0 : (_values$preinspection26 = values.preinspectionDetails) === null || _values$preinspection26 === void 0 ? void 0 : _values$preinspection26.preinspectionDatetime, 'DD/MM/YYYY')) !== null && _moment2 !== void 0 && _moment2.isAfter()) {
        errors.preinspectionDetails.preinspectionDatetime = '* cannot accept future date';
        errorCount += 1;
      }
    }

    if (errorCount === 0) {
      errors = {};
    }

    return errors;
  };

  var renewPolicyVariables = function renewPolicyVariables(values) {
    var _reactiveVarData$revi4, _data$9, _data$9$intermediaryD, _data$10, _data$10$intermediary, _data$11, _data$11$intermediary, _data$12, _data$12$intermediary, _data$13, _data$13$intermediary, _data$14, _data$14$intermediary, _reactiveVarData$prop11, _reactiveVarData$prem11;

    var getReceiptDetails = function getReceiptDetails() {
      var receiptArr = [];

      if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Cheque', 'value', 'code')) {
        values === null || values === void 0 ? void 0 : values.cheque.forEach(function (_, idx) {
          var _values$cheque$idx11, _values$cheque$idx12, _values$cheque$idx13, _values$cheque$idx14, _values$cheque$idx15, _values$cheque$idx16, _values$cheque$idx17, _values$cheque$idx18;

          receiptArr.push({
            paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
            receiptAmount: parseFloat(values === null || values === void 0 ? void 0 : (_values$cheque$idx11 = values.cheque[idx]) === null || _values$cheque$idx11 === void 0 ? void 0 : _values$cheque$idx11.paymentAmount),
            cdAccNumber: null,
            cheqDDTransReferenceNo: values === null || values === void 0 ? void 0 : (_values$cheque$idx12 = values.cheque[idx]) === null || _values$cheque$idx12 === void 0 ? void 0 : _values$cheque$idx12.chequeNumber,
            cheqDDTransDate: values === null || values === void 0 ? void 0 : (_values$cheque$idx13 = values.cheque[idx]) === null || _values$cheque$idx13 === void 0 ? void 0 : _values$cheque$idx13.chequeDate,
            // chequeType: values?.cheque[idx].chequeType,
            chequeType: "",
            ifscCode: values === null || values === void 0 ? void 0 : (_values$cheque$idx14 = values.cheque[idx]) === null || _values$cheque$idx14 === void 0 ? void 0 : _values$cheque$idx14.ifscCode,
            bankName: values === null || values === void 0 ? void 0 : (_values$cheque$idx15 = values.cheque[idx]) === null || _values$cheque$idx15 === void 0 ? void 0 : _values$cheque$idx15.bankName,
            bankCode: values === null || values === void 0 ? void 0 : (_values$cheque$idx16 = values.cheque[idx]) === null || _values$cheque$idx16 === void 0 ? void 0 : _values$cheque$idx16.bankCode,
            bankLocation: values === null || values === void 0 ? void 0 : (_values$cheque$idx17 = values.cheque[idx]) === null || _values$cheque$idx17 === void 0 ? void 0 : _values$cheque$idx17.branchLocation,
            branchName: values === null || values === void 0 ? void 0 : (_values$cheque$idx18 = values.cheque[idx]) === null || _values$cheque$idx18 === void 0 ? void 0 : _values$cheque$idx18.branchName,
            gstNumber: null
          });
        });
      } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Demand Draft', 'value', 'code')) {
        values === null || values === void 0 ? void 0 : values.demandDraft.forEach(function (_, idx) {
          var _values$demandDraft$i14, _values$demandDraft$i15, _values$demandDraft$i16, _values$demandDraft$i17, _values$demandDraft$i18, _values$demandDraft$i19, _values$demandDraft$i20, _values$demandDraft$i21;

          receiptArr.push({
            paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
            receiptAmount: parseFloat(values === null || values === void 0 ? void 0 : (_values$demandDraft$i14 = values.demandDraft[idx]) === null || _values$demandDraft$i14 === void 0 ? void 0 : _values$demandDraft$i14.paymentAmount),
            cdAccNumber: null,
            cheqDDTransReferenceNo: values === null || values === void 0 ? void 0 : (_values$demandDraft$i15 = values.demandDraft[idx]) === null || _values$demandDraft$i15 === void 0 ? void 0 : _values$demandDraft$i15.ddNumber,
            cheqDDTransDate: values === null || values === void 0 ? void 0 : (_values$demandDraft$i16 = values.demandDraft[idx]) === null || _values$demandDraft$i16 === void 0 ? void 0 : _values$demandDraft$i16.ddDate,
            chequeType: null,
            ifscCode: values === null || values === void 0 ? void 0 : (_values$demandDraft$i17 = values.demandDraft[idx]) === null || _values$demandDraft$i17 === void 0 ? void 0 : _values$demandDraft$i17.ifscCode,
            bankName: values === null || values === void 0 ? void 0 : (_values$demandDraft$i18 = values.demandDraft[idx]) === null || _values$demandDraft$i18 === void 0 ? void 0 : _values$demandDraft$i18.bankName,
            bankCode: values === null || values === void 0 ? void 0 : (_values$demandDraft$i19 = values.demandDraft[idx]) === null || _values$demandDraft$i19 === void 0 ? void 0 : _values$demandDraft$i19.bankCode,
            bankLocation: values === null || values === void 0 ? void 0 : (_values$demandDraft$i20 = values.demandDraft[idx]) === null || _values$demandDraft$i20 === void 0 ? void 0 : _values$demandDraft$i20.branchLocation,
            branchName: values === null || values === void 0 ? void 0 : (_values$demandDraft$i21 = values.demandDraft[idx]) === null || _values$demandDraft$i21 === void 0 ? void 0 : _values$demandDraft$i21.branchName,
            gstNumber: null
          });
        });
      } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Offline Payment', 'value', 'code')) {
        var _reactiveVarData$prem8, _values$onlinePayment7;

        receiptArr.push({
          paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
          receiptAmount: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem8 = reactiveVarData.premiumData) === null || _reactiveVarData$prem8 === void 0 ? void 0 : _reactiveVarData$prem8.totalPremium,
          cdAccNumber: null,
          cheqDDTransReferenceNo: values === null || values === void 0 ? void 0 : (_values$onlinePayment7 = values.onlinePayment) === null || _values$onlinePayment7 === void 0 ? void 0 : _values$onlinePayment7.transactionId,
          cheqDDTransDate: null,
          chequeType: null,
          ifscCode: null,
          bankName: null,
          bankCode: null,
          bankLocation: null,
          branchName: null,
          gstNumber: null
        });
      } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'CD Wallet', 'value', 'code')) {
        var _reactiveVarData$prem9, _values$cdWallet5;

        receiptArr.push({
          paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
          receiptAmount: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem9 = reactiveVarData.premiumData) === null || _reactiveVarData$prem9 === void 0 ? void 0 : _reactiveVarData$prem9.totalPremium,
          cdAccNumber: values === null || values === void 0 ? void 0 : (_values$cdWallet5 = values.cdWallet) === null || _values$cdWallet5 === void 0 ? void 0 : _values$cdWallet5.cdAccountNo,
          cheqDDTransReferenceNo: null,
          cheqDDTransDate: null,
          chequeType: null,
          ifscCode: null,
          bankName: null,
          bankCode: null,
          bankLocation: null,
          branchName: null,
          gstNumber: null
        });
      } else {
        var _reactiveVarData$prem10;

        receiptArr.push({
          paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
          receiptAmount: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem10 = reactiveVarData.premiumData) === null || _reactiveVarData$prem10 === void 0 ? void 0 : _reactiveVarData$prem10.totalPremium,
          cdAccNumber: null,
          cheqDDTransReferenceNo: null,
          cheqDDTransDate: null,
          chequeType: null,
          ifscCode: null,
          bankName: null,
          bankCode: null,
          bankLocation: null,
          branchName: null,
          gstNumber: null
        });
      }

      return receiptArr;
    };

    return {
      input: {
        businessType: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.businessType,
        productCode: productCode,
        commonDetails: {
          proposalPaymentType: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$revi4 = reactiveVarData.reviewAndConfirmTabDetails) === null || _reactiveVarData$revi4 === void 0 ? void 0 : _reactiveVarData$revi4.proposalPaymentType,
          proposalNumber: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber,
          intermediary: {
            intermediaryCode: (_data$9 = data["".concat(reactiveVarName)]) !== null && _data$9 !== void 0 && (_data$9$intermediaryD = _data$9.intermediaryDetails) !== null && _data$9$intermediaryD !== void 0 && _data$9$intermediaryD.code ? "".concat((_data$10 = data["".concat(reactiveVarName)]) === null || _data$10 === void 0 ? void 0 : (_data$10$intermediary = _data$10.intermediaryDetails) === null || _data$10$intermediary === void 0 ? void 0 : _data$10$intermediary.code) : '',
            locationCode: (_data$11 = data["".concat(reactiveVarName)]) !== null && _data$11 !== void 0 && (_data$11$intermediary = _data$11.intermediaryDetails) !== null && _data$11$intermediary !== void 0 && _data$11$intermediary.location ? "".concat((_data$12 = data["".concat(reactiveVarName)]) === null || _data$12 === void 0 ? void 0 : (_data$12$intermediary = _data$12.intermediaryDetails) === null || _data$12$intermediary === void 0 ? void 0 : _data$12$intermediary.location) : '',
            fieldUserCode: (_data$13 = data["".concat(reactiveVarName)]) !== null && _data$13 !== void 0 && (_data$13$intermediary = _data$13.intermediaryDetails) !== null && _data$13$intermediary !== void 0 && _data$13$intermediary.fieldUserCode ? "".concat((_data$14 = data["".concat(reactiveVarName)]) === null || _data$14 === void 0 ? void 0 : (_data$14$intermediary = _data$14.intermediaryDetails) === null || _data$14$intermediary === void 0 ? void 0 : _data$14$intermediary.fieldUserCode) : ''
          },
          customerID: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop11 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop11 === void 0 ? void 0 : _reactiveVarData$prop11.id,
          totalPremium: parseFloat(reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem11 = reactiveVarData.premiumData) === null || _reactiveVarData$prem11 === void 0 ? void 0 : _reactiveVarData$prem11.totalPremium),
          payerType: values === null || values === void 0 ? void 0 : values.payerType,
          policy_Num: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.businessType) === 'Renewal Business' ? reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.policyNumber : '' //SAEA BT20641

        },
        receiptDetails: getReceiptDetails(),
        modeOfOperation: modeOfOperation ? modeOfOperation : (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.businessType) === 'Renewal Business' ? 'RENEWPOLICY' : undefined
      }
    };
  };

  var getKashPayVariables = function getKashPayVariables(values, refillCDAccDtls) {
    var _data$15, _data$15$intermediary, _data$16, _data$16$intermediary, _data$17, _data$17$intermediary, _data$18, _data$18$intermediary, _reactiveVarData$prop12, _reactiveVarData$prop13, _reactiveVarData$prop14, _reactiveVarData$prop15, _reactiveVarData$prop16, _reactiveVarData$prop17, _reactiveVarData$prop18, _reactiveVarData$prop19, _reactiveVarData$prop20, _reactiveVarData$prop21, _reactiveVarData$inte3, _reactiveVarData$prem15, _reactiveVarData$prem16, _reactiveVarData$prop22, _reactiveVarData$revi5, _reactiveVarData$poli2, _values$cdWallet7;

    var getReceiptDetails = function getReceiptDetails() {
      var receiptArr = [];

      if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Cheque', 'value', 'code')) {
        values === null || values === void 0 ? void 0 : values.cheque.forEach(function (_, idx) {
          var _values$cheque$idx19, _values$cheque$idx20, _values$cheque$idx21, _values$cheque$idx22, _values$cheque$idx23, _values$cheque$idx24, _values$cheque$idx25, _values$cheque$idx26;

          receiptArr.push({
            paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
            receiptAmount: parseFloat(values === null || values === void 0 ? void 0 : (_values$cheque$idx19 = values.cheque[idx]) === null || _values$cheque$idx19 === void 0 ? void 0 : _values$cheque$idx19.paymentAmount),
            cdAccNumber: null,
            cheqDDTransReferenceNo: values === null || values === void 0 ? void 0 : (_values$cheque$idx20 = values.cheque[idx]) === null || _values$cheque$idx20 === void 0 ? void 0 : _values$cheque$idx20.chequeNumber,
            cheqDDTransDate: values === null || values === void 0 ? void 0 : (_values$cheque$idx21 = values.cheque[idx]) === null || _values$cheque$idx21 === void 0 ? void 0 : _values$cheque$idx21.chequeDate,
            // chequeType: values?.cheque[idx].chequeType,
            chequeType: "",
            ifscCode: values === null || values === void 0 ? void 0 : (_values$cheque$idx22 = values.cheque[idx]) === null || _values$cheque$idx22 === void 0 ? void 0 : _values$cheque$idx22.ifscCode,
            bankName: values === null || values === void 0 ? void 0 : (_values$cheque$idx23 = values.cheque[idx]) === null || _values$cheque$idx23 === void 0 ? void 0 : _values$cheque$idx23.bankName,
            bankCode: values === null || values === void 0 ? void 0 : (_values$cheque$idx24 = values.cheque[idx]) === null || _values$cheque$idx24 === void 0 ? void 0 : _values$cheque$idx24.bankCode,
            bankLocation: values === null || values === void 0 ? void 0 : (_values$cheque$idx25 = values.cheque[idx]) === null || _values$cheque$idx25 === void 0 ? void 0 : _values$cheque$idx25.branchLocation,
            branchName: values === null || values === void 0 ? void 0 : (_values$cheque$idx26 = values.cheque[idx]) === null || _values$cheque$idx26 === void 0 ? void 0 : _values$cheque$idx26.branchName,
            gstNumber: null
          });
        });
      } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Demand Draft', 'value', 'code')) {
        values === null || values === void 0 ? void 0 : values.demandDraft.forEach(function (_, idx) {
          var _values$demandDraft$i22, _values$demandDraft$i23, _values$demandDraft$i24, _values$demandDraft$i25, _values$demandDraft$i26, _values$demandDraft$i27, _values$demandDraft$i28, _values$demandDraft$i29;

          receiptArr.push({
            paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
            receiptAmount: parseFloat(values === null || values === void 0 ? void 0 : (_values$demandDraft$i22 = values.demandDraft[idx]) === null || _values$demandDraft$i22 === void 0 ? void 0 : _values$demandDraft$i22.paymentAmount),
            cdAccNumber: null,
            cheqDDTransReferenceNo: values === null || values === void 0 ? void 0 : (_values$demandDraft$i23 = values.demandDraft[idx]) === null || _values$demandDraft$i23 === void 0 ? void 0 : _values$demandDraft$i23.ddNumber,
            cheqDDTransDate: values === null || values === void 0 ? void 0 : (_values$demandDraft$i24 = values.demandDraft[idx]) === null || _values$demandDraft$i24 === void 0 ? void 0 : _values$demandDraft$i24.ddDate,
            chequeType: null,
            ifscCode: values === null || values === void 0 ? void 0 : (_values$demandDraft$i25 = values.demandDraft[idx]) === null || _values$demandDraft$i25 === void 0 ? void 0 : _values$demandDraft$i25.ifscCode,
            bankName: values === null || values === void 0 ? void 0 : (_values$demandDraft$i26 = values.demandDraft[idx]) === null || _values$demandDraft$i26 === void 0 ? void 0 : _values$demandDraft$i26.bankName,
            bankCode: values === null || values === void 0 ? void 0 : (_values$demandDraft$i27 = values.demandDraft[idx]) === null || _values$demandDraft$i27 === void 0 ? void 0 : _values$demandDraft$i27.bankCode,
            bankLocation: values === null || values === void 0 ? void 0 : (_values$demandDraft$i28 = values.demandDraft[idx]) === null || _values$demandDraft$i28 === void 0 ? void 0 : _values$demandDraft$i28.branchLocation,
            branchName: values === null || values === void 0 ? void 0 : (_values$demandDraft$i29 = values.demandDraft[idx]) === null || _values$demandDraft$i29 === void 0 ? void 0 : _values$demandDraft$i29.branchName,
            gstNumber: null
          });
        });
      } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'Offline Payment', 'value', 'code')) {
        var _reactiveVarData$prem12, _values$onlinePayment8;

        receiptArr.push({
          paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
          receiptAmount: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem12 = reactiveVarData.premiumData) === null || _reactiveVarData$prem12 === void 0 ? void 0 : _reactiveVarData$prem12.totalPremium,
          cdAccNumber: null,
          cheqDDTransReferenceNo: values === null || values === void 0 ? void 0 : (_values$onlinePayment8 = values.onlinePayment) === null || _values$onlinePayment8 === void 0 ? void 0 : _values$onlinePayment8.transactionId,
          cheqDDTransDate: null,
          chequeType: null,
          ifscCode: null,
          bankName: null,
          bankCode: null,
          bankLocation: null,
          branchName: null,
          gstNumber: null
        });
      } else if ((values === null || values === void 0 ? void 0 : values.paymentMethod) === getDomainData(PaymentTypeList, 'CD Wallet', 'value', 'code')) {
        var _reactiveVarData$prem13, _values$cdWallet6;

        receiptArr.push({
          paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
          receiptAmount: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem13 = reactiveVarData.premiumData) === null || _reactiveVarData$prem13 === void 0 ? void 0 : _reactiveVarData$prem13.totalPremium,
          cdAccNumber: values === null || values === void 0 ? void 0 : (_values$cdWallet6 = values.cdWallet) === null || _values$cdWallet6 === void 0 ? void 0 : _values$cdWallet6.cdAccountNo,
          cheqDDTransReferenceNo: null,
          cheqDDTransDate: null,
          chequeType: null,
          ifscCode: null,
          bankName: null,
          bankCode: null,
          bankLocation: null,
          branchName: null,
          gstNumber: null
        });
      } else {
        var _reactiveVarData$prem14;

        receiptArr.push({
          paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
          receiptAmount: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem14 = reactiveVarData.premiumData) === null || _reactiveVarData$prem14 === void 0 ? void 0 : _reactiveVarData$prem14.totalPremium,
          cdAccNumber: null,
          cheqDDTransReferenceNo: null,
          cheqDDTransDate: null,
          chequeType: null,
          ifscCode: null,
          bankName: null,
          bankCode: null,
          bankLocation: null,
          branchName: null,
          gstNumber: null
        });
      }

      return receiptArr;
    };

    return {
      input: {
        imdCode: (_data$15 = data["".concat(reactiveVarName)]) !== null && _data$15 !== void 0 && (_data$15$intermediary = _data$15.intermediaryDetails) !== null && _data$15$intermediary !== void 0 && _data$15$intermediary.code ? "".concat((_data$16 = data["".concat(reactiveVarName)]) === null || _data$16 === void 0 ? void 0 : (_data$16$intermediary = _data$16.intermediaryDetails) === null || _data$16$intermediary === void 0 ? void 0 : _data$16$intermediary.code) : '',
        imdName: (_data$17 = data["".concat(reactiveVarName)]) !== null && _data$17 !== void 0 && (_data$17$intermediary = _data$17.intermediaryDetails) !== null && _data$17$intermediary !== void 0 && _data$17$intermediary.value ? "".concat((_data$18 = data["".concat(reactiveVarName)]) === null || _data$18 === void 0 ? void 0 : (_data$18$intermediary = _data$18.intermediaryDetails) === null || _data$18$intermediary === void 0 ? void 0 : _data$18$intermediary.value) : '',
        payerName: (values === null || values === void 0 ? void 0 : values.payerType) === getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') ? (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop12 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop12 === void 0 ? void 0 : _reactiveVarData$prop12.customerType) === getDomainData(customerTypeList, 'Individual', 'value', 'code') ? [getDomainData(salutationList, reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop13 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop13 === void 0 ? void 0 : (_reactiveVarData$prop14 = _reactiveVarData$prop13.title) === null || _reactiveVarData$prop14 === void 0 ? void 0 : _reactiveVarData$prop14.trim(), 'code', 'value'), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop15 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop15 === void 0 ? void 0 : (_reactiveVarData$prop16 = _reactiveVarData$prop15.firstName) === null || _reactiveVarData$prop16 === void 0 ? void 0 : _reactiveVarData$prop16.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop17 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop17 === void 0 ? void 0 : (_reactiveVarData$prop18 = _reactiveVarData$prop17.middleName) === null || _reactiveVarData$prop18 === void 0 ? void 0 : _reactiveVarData$prop18.trim(), reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop19 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop19 === void 0 ? void 0 : (_reactiveVarData$prop20 = _reactiveVarData$prop19.lastName) === null || _reactiveVarData$prop20 === void 0 ? void 0 : _reactiveVarData$prop20.trim()].filter(function (n) {
          return n;
        }).join(' ') : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop21 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop21 === void 0 ? void 0 : _reactiveVarData$prop21.orgName : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$inte3 = reactiveVarData.intermediaryDetails) === null || _reactiveVarData$inte3 === void 0 ? void 0 : _reactiveVarData$inte3.intermediaryName,
        receiptNumber: refillCDAccDtls === null || refillCDAccDtls === void 0 ? void 0 : refillCDAccDtls.receiptID,
        receiptAmount: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem15 = reactiveVarData.premiumData) === null || _reactiveVarData$prem15 === void 0 ? void 0 : (_reactiveVarData$prem16 = _reactiveVarData$prem15.totalPremium) === null || _reactiveVarData$prem16 === void 0 ? void 0 : _reactiveVarData$prem16.toString(),
        customerID: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prop22 = reactiveVarData.proposerDetails) === null || _reactiveVarData$prop22 === void 0 ? void 0 : _reactiveVarData$prop22.id,
        proposalPaymentType: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$revi5 = reactiveVarData.reviewAndConfirmTabDetails) === null || _reactiveVarData$revi5 === void 0 ? void 0 : _reactiveVarData$revi5.proposalPaymentType,
        proposalNumber: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : reactiveVarData.proposalNumber,
        proposalDate: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$poli2 = reactiveVarData.policy) === null || _reactiveVarData$poli2 === void 0 ? void 0 : _reactiveVarData$poli2.startDate,
        policyNo: refillCDAccDtls === null || refillCDAccDtls === void 0 ? void 0 : refillCDAccDtls.policyNo,
        productName: productName,
        cdAccNo: values === null || values === void 0 ? void 0 : (_values$cdWallet7 = values.cdWallet) === null || _values$cdWallet7 === void 0 ? void 0 : _values$cdWallet7.cdAccountNo,
        payerType: values === null || values === void 0 ? void 0 : values.payerType,
        type: "proposal",
        paymentMode: values === null || values === void 0 ? void 0 : values.paymentMethod,
        receiptDetails: getReceiptDetails()
      }
    };
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(values) {
      var _data$issuePolicy4, _data$issuePolicy5, _data$issuePolicy6, _data$issuePolicy7, _data$issuePolicy8, _data$issuePolicy9, _data$issuePolicy10, _data$issuePolicy11, _data$issuePolicy12, issuePolicy, _yield$issuePolicy, _data, _data$issuePolicy, _data$issuePolicy2, _data$issuePolicy3, kashPaySlipQuery;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(Object.keys(validate(values)).length === 0 && Object.keys(validatePreinspection(values)).length === 0)) {
                _context2.next = 29;
                break;
              }

              _context2.prev = 1;
              issuePolicy = mutateQuery({
                mutation: ISSUE_POLICY,
                variables: renewPolicyVariables(values)
              });
              setCustomLoadingMessage('Processing');
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
              setLoadingStep(true);
              _context2.next = 8;
              return issuePolicy;

            case 8:
              _yield$issuePolicy = _context2.sent;
              _data = _yield$issuePolicy.data;
              setLoadingStep(false);
              /* kashPaySlipQuery - Inserting the Receipt Number in master table to generate payslip*/

              if (!((values === null || values === void 0 ? void 0 : values.paymentMethod) === 'C' || (values === null || values === void 0 ? void 0 : values.paymentMethod) === 'D')) {
                _context2.next = 17;
                break;
              }

              kashPaySlipQuery = mutateQuery({
                mutation: KASH_PASH_SLIP,
                variables: getKashPayVariables(values, {
                  receiptID: _data !== null && _data !== void 0 && (_data$issuePolicy = _data.issuePolicy) !== null && _data$issuePolicy !== void 0 && _data$issuePolicy.receiptID ? _data === null || _data === void 0 ? void 0 : (_data$issuePolicy2 = _data.issuePolicy) === null || _data$issuePolicy2 === void 0 ? void 0 : _data$issuePolicy2.receiptID : [],
                  policyNo: reformData(_data === null || _data === void 0 ? void 0 : (_data$issuePolicy3 = _data.issuePolicy) === null || _data$issuePolicy3 === void 0 ? void 0 : _data$issuePolicy3.policyNo, '')
                })
              });
              _context2.next = 15;
              return kashPaySlipQuery;

            case 15:

            case 17:
              updateReactiveVar({
                isPolicyIssued: true,
                issuedPolicyData: {
                  policyNo: reformData(_data === null || _data === void 0 ? void 0 : (_data$issuePolicy4 = _data.issuePolicy) === null || _data$issuePolicy4 === void 0 ? void 0 : _data$issuePolicy4.policyNo, ''),
                  receiptID: _data !== null && _data !== void 0 && (_data$issuePolicy5 = _data.issuePolicy) !== null && _data$issuePolicy5 !== void 0 && _data$issuePolicy5.receiptID ? _data === null || _data === void 0 ? void 0 : (_data$issuePolicy6 = _data.issuePolicy) === null || _data$issuePolicy6 === void 0 ? void 0 : _data$issuePolicy6.receiptID : [],
                  referenceNumber: reformData(_data === null || _data === void 0 ? void 0 : (_data$issuePolicy7 = _data.issuePolicy) === null || _data$issuePolicy7 === void 0 ? void 0 : _data$issuePolicy7.referenceNumber, ''),
                  digiLink: reformData(_data === null || _data === void 0 ? void 0 : (_data$issuePolicy8 = _data.issuePolicy) === null || _data$issuePolicy8 === void 0 ? void 0 : _data$issuePolicy8.digiLink, ''),
                  displayMessage: reformData(_data === null || _data === void 0 ? void 0 : (_data$issuePolicy9 = _data.issuePolicy) === null || _data$issuePolicy9 === void 0 ? void 0 : _data$issuePolicy9.displayMessage, ''),
                  additionalMessage: reformData(_data === null || _data === void 0 ? void 0 : (_data$issuePolicy10 = _data.issuePolicy) === null || _data$issuePolicy10 === void 0 ? void 0 : _data$issuePolicy10.additionalMessage, '')
                },
                premiumDetails: values
              });

              if (_data !== null && _data !== void 0 && (_data$issuePolicy11 = _data.issuePolicy) !== null && _data$issuePolicy11 !== void 0 && _data$issuePolicy11.policyNo && (_data === null || _data === void 0 ? void 0 : (_data$issuePolicy12 = _data.issuePolicy) === null || _data$issuePolicy12 === void 0 ? void 0 : _data$issuePolicy12.policyNo.length) > 0) {
                setParentAlerts([{
                  header: 'Policy issue success',
                  id: Date.now(),
                  content: /*#__PURE__*/React.createElement("div", {
                    className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                  }, /*#__PURE__*/React.createElement("span", null, 'Policy issued successfully')),
                  type: 'success',
                  timeout: null,
                  disableClose: false
                }]);
              }

              showSuccessMsg(true);
              return _context2.abrupt("return", true);

            case 23:
              _context2.prev = 23;
              _context2.t0 = _context2["catch"](1);
              setCustomLoadingMessage(null);
              setLoadingStep(false);
              setParentAlerts([{
                header: 'Error',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, /*#__PURE__*/React.createElement("span", null, _context2.t0.message)),
                type: 'error',
                timeout: null,
                disableClose: false
              }]);
              return _context2.abrupt("return", false);

            case 29:
              return _context2.abrupt("return", false);

            case 30:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 23]]);
    }));

    return function onSubmit(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var initialValues = {
    termsAndConditions: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem17 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem17 === void 0 ? void 0 : _reactiveVarData$prem17.termsAndConditions,
    paymentMethod: reactiveVarData !== null && reactiveVarData !== void 0 && (_reactiveVarData$prem18 = reactiveVarData.premiumDetails) !== null && _reactiveVarData$prem18 !== void 0 && _reactiveVarData$prem18.paymentMethod ? reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem19 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem19 === void 0 ? void 0 : _reactiveVarData$prem19.paymentMethod : getDomainData(PaymentTypeList, (_PaymentTypeList$ = PaymentTypeList[0]) === null || _PaymentTypeList$ === void 0 ? void 0 : _PaymentTypeList$.value, 'value', 'code'),
    payerType: reactiveVarData !== null && reactiveVarData !== void 0 && (_reactiveVarData$prem20 = reactiveVarData.premiumDetails) !== null && _reactiveVarData$prem20 !== void 0 && _reactiveVarData$prem20.payerType ? reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem21 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem21 === void 0 ? void 0 : _reactiveVarData$prem21.payerType : PayMethodPayerTypeList ? getDomainData(PayMethodPayerTypeList, 'Customer', 'value', 'code') : '',
    preinspectionDetails: {
      preinspectionAgencyName: '',
      preInspectionNumber: '',
      preinspectionDatetime: '',
      preinspectiontime: '',
      status: '',
      remarks: '',
      isPreInspectionVerified: '',
      isVehicleInspectionNeeded: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$busi = reactiveVarData.businessType) === null || _reactiveVarData$busi === void 0 ? void 0 : _reactiveVarData$busi.toLowerCase()) === 'used car' ? true : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prei = reactiveVarData.preinspectionDetails) === null || _reactiveVarData$prei === void 0 ? void 0 : _reactiveVarData$prei.isVehicleInspectionNeeded
    },
    onlinePayment: {
      transactionId: reactiveVarData !== null && reactiveVarData !== void 0 && (_reactiveVarData$prem22 = reactiveVarData.premiumDetails) !== null && _reactiveVarData$prem22 !== void 0 && (_reactiveVarData$prem23 = _reactiveVarData$prem22.onlinePayment) !== null && _reactiveVarData$prem23 !== void 0 && _reactiveVarData$prem23.transactionId ? reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem24 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem24 === void 0 ? void 0 : (_reactiveVarData$prem25 = _reactiveVarData$prem24.onlinePayment) === null || _reactiveVarData$prem25 === void 0 ? void 0 : _reactiveVarData$prem25.transactionId : '',
      isTransactionIdVerified: reactiveVarData !== null && reactiveVarData !== void 0 && (_reactiveVarData$prem26 = reactiveVarData.premiumDetails) !== null && _reactiveVarData$prem26 !== void 0 && (_reactiveVarData$prem27 = _reactiveVarData$prem26.onlinePayment) !== null && _reactiveVarData$prem27 !== void 0 && _reactiveVarData$prem27.isTransactionIdVerified ? reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem28 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem28 === void 0 ? void 0 : (_reactiveVarData$prem29 = _reactiveVarData$prem28.onlinePayment) === null || _reactiveVarData$prem29 === void 0 ? void 0 : _reactiveVarData$prem29.isTransactionIdVerified : false
    },
    cdWallet: {
      cdAccountNo: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem30 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem30 === void 0 ? void 0 : (_reactiveVarData$prem31 = _reactiveVarData$prem30.cdWallet) === null || _reactiveVarData$prem31 === void 0 ? void 0 : _reactiveVarData$prem31.cdAccountNo,
      cdAccountBalance: reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem32 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem32 === void 0 ? void 0 : (_reactiveVarData$prem33 = _reactiveVarData$prem32.cdWallet) === null || _reactiveVarData$prem33 === void 0 ? void 0 : _reactiveVarData$prem33.cdAccountBalance,
      cdAccountCount: 0
    },
    cheque: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem34 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem34 === void 0 ? void 0 : (_reactiveVarData$prem35 = _reactiveVarData$prem34.cheque) === null || _reactiveVarData$prem35 === void 0 ? void 0 : _reactiveVarData$prem35.length) === 0 ? [{
      ifscCode: '',
      bankName: '',
      bankCode: '',
      chequeType: '',
      chequeNumber: '',
      chequeDate: dateTimeData === null || dateTimeData === void 0 ? void 0 : (_dateTimeData$datetim3 = dateTimeData.datetimeValue) === null || _dateTimeData$datetim3 === void 0 ? void 0 : _dateTimeData$datetim3.date,
      paymentAmount: '',
      branchName: '',
      branchLocation: ''
    }] : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem36 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem36 === void 0 ? void 0 : (_reactiveVarData$prem37 = _reactiveVarData$prem36.cheque) === null || _reactiveVarData$prem37 === void 0 ? void 0 : _reactiveVarData$prem37.map(function (cheque) {
      var _dateTimeData$datetim4;

      return _objectSpread2(_objectSpread2({}, cheque), {}, {
        chequeDate: dateTimeData === null || dateTimeData === void 0 ? void 0 : (_dateTimeData$datetim4 = dateTimeData.datetimeValue) === null || _dateTimeData$datetim4 === void 0 ? void 0 : _dateTimeData$datetim4.date
      });
    }),
    demandDraft: (reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem38 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem38 === void 0 ? void 0 : (_reactiveVarData$prem39 = _reactiveVarData$prem38.demandDraft) === null || _reactiveVarData$prem39 === void 0 ? void 0 : _reactiveVarData$prem39.length) === 0 ? [{
      ifscCode: '',
      bankName: '',
      bankCode: '',
      ddNumber: '',
      ddDate: dateTimeData === null || dateTimeData === void 0 ? void 0 : (_dateTimeData$datetim5 = dateTimeData.datetimeValue) === null || _dateTimeData$datetim5 === void 0 ? void 0 : _dateTimeData$datetim5.date,
      paymentAmount: '',
      branchName: '',
      branchLocation: ''
    }] : reactiveVarData === null || reactiveVarData === void 0 ? void 0 : (_reactiveVarData$prem40 = reactiveVarData.premiumDetails) === null || _reactiveVarData$prem40 === void 0 ? void 0 : (_reactiveVarData$prem41 = _reactiveVarData$prem40.demandDraft) === null || _reactiveVarData$prem41 === void 0 ? void 0 : _reactiveVarData$prem41.map(function (demandDraft) {
      var _dateTimeData$datetim6;

      return _objectSpread2(_objectSpread2({}, demandDraft), {}, {
        ddDate: dateTimeData === null || dateTimeData === void 0 ? void 0 : (_dateTimeData$datetim6 = dateTimeData.datetimeValue) === null || _dateTimeData$datetim6 === void 0 ? void 0 : _dateTimeData$datetim6.date
      });
    })
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaFormik, {
    innerRef: props.forwardedRef,
    initialValues: initialValues,
    enableReinitialize: true,
    validate: validate,
    onSubmit: onSubmit,
    validator: function validator() {
      return {};
    }
  }, /*#__PURE__*/React.createElement(RenewPayPremiumForm, {
    validate: validate
  })), /*#__PURE__*/React.createElement(TermsAndConditions, {
    setShow: setShow,
    showterms: showterms
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NotificationList, {
    items: alerts
  })));
}

export { CarPayPremium };
